<ng-container [ngSwitch]="redirectToExternalBankPage">
  <app-redirect-to-external-bank-wait
    [selectedBank]="selectedBank"
    *ngSwitchCase="'REDIRECT_TO_EXTERNAL_BANK_WAIT'"
  ></app-redirect-to-external-bank-wait>

  <app-redirect-to-external-bank-error
    *ngSwitchCase="'REDIRECT_TO_EXTERNAL_BANK_ERROR'"
  ></app-redirect-to-external-bank-error>
</ng-container>
